export default "__VITE_ASSET__C6jvz3sk__"